/** Espelha `backend/.../form-question-show-condition.interface.ts`. */
export interface FormQuestionShowCondition {
	question_number: number;
	answer_keys: string[];
}

function parseShowCondition(raw: unknown): FormQuestionShowCondition | null {
	if (typeof raw !== 'object' || raw === null || Array.isArray(raw))
		return null;
	const obj = raw as Record<string, unknown>;
	if (typeof obj.question_number !== 'number') return null;
	if (!Array.isArray(obj.answer_keys)) return null;
	if (!obj.answer_keys.every((k) => typeof k === 'string')) return null;
	return {
		question_number: obj.question_number,
		answer_keys: obj.answer_keys,
	};
}

export function isQuestionActive(
	question: { show_condition?: unknown },
	answers: Record<string, string | null>,
): boolean {
	const condition = parseShowCondition(question.show_condition);
	if (!condition) return true;

	const refAnswer = answers[String(condition.question_number)];
	return (
		refAnswer !== null &&
		refAnswer !== undefined &&
		refAnswer !== '' &&
		condition.answer_keys.includes(refAnswer)
	);
}

export function pruneInactiveQuestionAnswers(
	questions: Forms.FormQuestion[],
	answers: Record<string, string | null>,
): Record<string, string | null> {
	const next = { ...answers };
	for (const q of questions) {
		if (!isQuestionActive(q, next)) {
			delete next[String(q.number)];
		}
	}
	return next;
}

export function getActiveQuestions(
	questions: Forms.FormQuestion[],
	answers: Record<string, string | null>,
): Forms.FormQuestion[] {
	return [...questions]
		.sort((a, b) => a.number - b.number)
		.filter((q) => isQuestionActive(q, answers));
}

export function countAnsweredKeys(
	answers: Record<string, string | null> | undefined,
): number {
	if (!answers) return 0;
	return Object.values(answers).filter(
		(v) => v != null && String(v).trim() !== '',
	).length;
}
